import * as CL from '@design-system/component-library';
import { Children } from 'react';
import { useFormContext } from 'react-hook-form';
import { SelectedPurposeOfUseOrContact } from '../../../common/enums.js';
import type { CLSelectGroupProduct } from '../../../common/types/componentLibrary';
import type { SelectGroupItemWithIdProps } from '../../SelectGroup/SelectGroupItem.js';

export interface PurposeSelectGroupProps {
  children: React.ReactNode;
  selectedItem?: string;
  className?: string;
  fieldPrefix?: string;
  label?: string;
  onChangeSelectedGroup?: () => void;
}

export const PurposeOfUseSelectGroup = ({
  children,
  selectedItem,
  className,
  fieldPrefix = '',
  label,
  onChangeSelectedGroup,
}: PurposeSelectGroupProps) => {
  const { setValue } = useFormContext();
  const fieldName = `${fieldPrefix}selected`;

  const childArray = Children.toArray(children) as React.ReactElement<SelectGroupItemWithIdProps>[];

  const products: CLSelectGroupProduct[] = childArray
    .filter(child => !child.props.hidden)
    .map(child => ({
      id: child.props.id,
      selected: child.props.selected,
      name: child.props.title,
      icon: child.props.icon,
    }));

  const selectedChildComponent = childArray.find(child => child.props.id === selectedItem) || childArray[0];

  const setFieldValues = (value: string) => {
    setValue(fieldName, value, { shouldTouch: true });
    if (value === SelectedPurposeOfUseOrContact.CONTACT) {
      setValue(`${fieldPrefix}purposeOfUse`, undefined);
      setValue(`${fieldPrefix}costCenter`, '');
      setValue(`${fieldPrefix}employeeNumber`, '');
    } else if (value === SelectedPurposeOfUseOrContact.PURPOSEOFUSE) {
      setValue(`${fieldPrefix}contactId`, undefined);
      setValue(`${fieldPrefix}firstName`, '');
      setValue(`${fieldPrefix}lastName`, '');
      setValue(`${fieldPrefix}phoneNumber`, '');
      setValue(`${fieldPrefix}email`, '');
    }
  };

  return (
    <>
      <CL.SelectGroup
        className={className}
        name={fieldName}
        products={products}
        onChange={event => {
          if (onChangeSelectedGroup && selectedItem !== event) {
            onChangeSelectedGroup();
          }
          if (event) {
            setFieldValues(String(event));
          }
        }}
        value={selectedItem}
        label={label}
      />
      {selectedChildComponent}
    </>
  );
};
